.iFrame{display:block;width:100%;border:none;overflow-y:auto;overflow-x:hidden;height:100%}
/*# sourceMappingURL=tax-forms-iframe-content.component-5WZ3GVDA.css.map */
